export const restErrorHandler = (statusCode: number):void => {
    window.location.href = `/react/error/${statusCode}`;
}